export default __webpack_public_path__ + "static/media/mobile_organization.b4710bb2.png";